import { Injectable } from '@angular/core';
import {
  CommunityProfileSections,
  CommunityProfileWidgetConfig,
  CommunityProfileWidgetDefinitionList,
  CommunityProfileWidgetLocation,
  ProgramOrSectionType,
} from '@trp/community/interfaces';
import { CommunityWithVerifications } from '@trp/community/program-verification/interfaces';
import { MultiFamilyProgram } from '@trp/nationaldb/interfaces';
import { getSectionVerifiedByInformation } from '@trp/community/program-verification/common';

@Injectable()
export class CommunityWidgetInfoUtilService {
  doesMultiFamilyHaveAdditionalServices(program: MultiFamilyProgram) {
    return [
      program.hasEnforcement,
      program.hasTechnicalSupport,
      program.hasEducation,
      program.hasOrdinance,
    ].some((v) => v);
  }

  filterWidgetDefinitionListByLocation(
    definitionList: CommunityProfileWidgetDefinitionList,
    location: CommunityProfileWidgetLocation,
    isEditMode = false
  ) {
    return definitionList
      .filter((d) => d.locations.includes(location))
      .filter((d) => !isEditMode || d.isReadonly);
  }

  getSectionVerifiableProperties(
    communityProfileWidgetConfig: CommunityProfileWidgetConfig,
    section: Extract<CommunityProfileSections, ProgramOrSectionType>
  ) {
    return communityProfileWidgetConfig?.[section]?.propertiesToVerify ?? [];
  }

  getSectionLastVerifiedInfo(
    communityProfileWidgetConfig: CommunityProfileWidgetConfig,
    section: Extract<CommunityProfileSections, ProgramOrSectionType>,
    communityWithVerifications: CommunityWithVerifications | null | undefined
  ) {
    if (!communityWithVerifications) {
      return null;
    }

    return getSectionVerifiedByInformation(
      section,
      communityWithVerifications.verifications
    );
  }
}
